export default {"src":"/_next/static/media/brokenGlass_64.811aa501.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};